import { createApp } from 'vue'
import VueGtag from 'vue-gtag';
import VueCookies from 'vue3-cookies'
import VueTour from 'v3-tour'
import ToastPlugin from 'vue-toast-notification';

// Vuetify — selective imports for tree-shaking
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import {
  VApp, VContainer, VRow, VCol, VBtn, VIcon,
  VDialog, VCard, VCardTitle, VCardText, VCardActions,
  VToolbar, VToolbarTitle, VToolbarItems, VSpacer,
  VProgressCircular, VAlert,
  VNavigationDrawer, VList, VListItem,
  VDivider, VChip, VBadge, VBtnGroup,
  VSkeletonLoader, VTextField,
} from 'vuetify/components'
import { Resize, Scroll, Ripple, Touch } from 'vuetify/directives'

import '@mdi/font/css/materialdesignicons.css'
import 'vue-toast-notification/dist/theme-bootstrap.css';
import "v3-tour/dist/vue-tour.css";

import App from './App.vue'
import router from './router'
import store from './store';
import http from './plugins/axios';

const app = createApp(App)

// process.env.VUE_APP_GOOGLE_ANALYTICS_PROPERTY_ID
const gtagConfig = {
  appName: 'Tuneeca Flipbook',
  pageTrackerScreenviewEnabled: true,
  config: {
    id: "G-8VZCW378V1"
  },
  router
}

const vuetify = createVuetify({
  components: {
    VApp, VContainer, VRow, VCol, VBtn, VIcon,
    VDialog, VCard, VCardTitle, VCardText, VCardActions,
    VToolbar, VToolbarTitle, VToolbarItems, VSpacer,
    VProgressCircular, VAlert,
    VNavigationDrawer, VList, VListItem,
    VDivider, VChip, VBadge, VBtnGroup,
    VSkeletonLoader, VTextField,
  },
  directives: { Resize, Scroll, Ripple, Touch },
  icons: {
    defaultSet: 'mdi',
  },
})

const cookies = {
  expireTimes: "30d",
  path: "/",
  domain: "",
  secure: true,
  sameSite: "None"
}

const axiosConfig = {
  baseURL: process.env.VUE_APP_COMMERCE_API_URL
}

const toastConfig = {
  position: 'top-right'
}

app.use(router)
app.use(http, axiosConfig)
app.use(VueCookies, cookies);
app.use(vuetify)
app.use(VueGtag, gtagConfig)
app.use(store)
app.use(ToastPlugin, toastConfig)
app.use(VueTour)

app.mount('#app')
